import { IStepOption } from "ngx-ui-tour-md-menu";

export const stepKeys = {
  dealerScorecard: 'dealerScorecard',
  Application: 'Application',
  Profile: 'Profile',
  InfoIcon: "InfoIcon",
  lexusLearn: "LexusLearn",
  lexusPortal: "LexusPortal",
  certificationByLexus: "CertificationByLexus",
  Support: 'Support',
  Home: 'home',
  StaffMaster: 'staffMaster',
  JobRoleSummary: 'JobRoleSummary',
  DealerTrainingBilling: 'DealerTrainingBilling',
  EventBilling:'EventBilling',
  ElevateBilling: 'ElevateBilling',
  AseLexus: 'AseLexus',
  LexusTurnoverReport: 'LexusTurnoverReport',
  jobHistory: 'jobHistory',
  distributionList: 'distributionList',
  tenure: 'tenure',
  userRoleSettings: 'userRoleSettings',
  information: 'Information',
  eliteCertificationReport: 'eliteCertificationReport',
  eventDashboard: 'eventDashboard',
  eventAdmin: 'eventAdmin',
  impactAnalysis: 'impactAnalysis',
  googleAnalytics: 'googleAnalytics',
  survey:'survey'
}
export const matTourSteps: IStepOption[] = [{
  anchorId: stepKeys['Application'],
  content: 'Let us walk you throught the important features in the application. In case you wish to skip please press close (X), else to continue press NEXT.',
  title: 'Welcome to CBL Reports Dashboard!'
}, {
  anchorId: stepKeys['InfoIcon'],
  title: 'Display Info',
  placement: {
    yPosition: 'above',
    xPosition: 'after'
  },
  content: "Thank you for taking the feature tour! This feature walkthrough is available on each of the tabs. Anytime you need to know something, remember we are here to help."
}, {
  anchorId: stepKeys['Profile'],
  content: 'View your role/workday and log out of the application.',
  title: 'Profile',
  placement: {
    yPosition: 'above'
  }
}, {
  anchorId: stepKeys['Home'],
  content: 'Important information about the program can be found on this page. Click on this tab anytime to comeback to the home page.',
  title: 'CBL Report Dashboard',
  placement: {
    horizontal: true
  }
}, {
  anchorId: stepKeys['StaffMaster'],
  content: 'View the complete details of any associate synced from the Staff Master.',
  title: 'Staff Master',
  placement: {
    horizontal: true
  }
}, {
  anchorId: stepKeys['JobRoleSummary'],
  title: 'Job Role Summary',
  placement: {
    horizontal: true
  },
  content: 'View the overall total count and the count of primary and secondary job roles of all Lexus associates by area, district, and certification.'
}, {
  anchorId: stepKeys['DealerTrainingBilling'],
  title: 'Dealers Billing',
  placement: {
    horizontal: true
  },
  content: 'View the Lexus dealer billing details and trends through summary charts, and manage exception payments.'
}, {
  anchorId: stepKeys['ElevateBilling'],
  title: 'Elevate Billing',
  placement: {
    horizontal: true
  },
  content: 'View the annual billing trends for Elevate events, including the billed amount.'
}, {
  anchorId: stepKeys['AseLexus'],
  title: 'ASE',
  placement: {
    horizontal: true
  },
  content: 'View the ASE certification details (new, updated, expired) of active associates.'
}, {
  anchorId: stepKeys['LexusTurnoverReport'],
  title: 'Lexus Turnover report',
  placement: {
    horizontal: true
  },
  content: 'View the annual turnover report for Lexus by area, district, dealer, and specific job role for the year.'
}, {
  anchorId: stepKeys['jobHistory'],
  title: 'Job History',
  placement: {
    yPosition: 'above',
    horizontal: true
  },
  content: 'View the job enrollment, certification and dealer history of all Lexus/Toyota associates (active, inactive, or terminated).'
},
{
  anchorId: stepKeys['distributionList'],
  title: 'Distribution List',
  placement: {
    yPosition: 'above',
    horizontal: true
  },
  content: `View and download the associate's contact information, including SPIN, name, and email, based on their primary and secondary job roles.`
}, {
  anchorId: stepKeys['tenure'],
  title: 'Tenure',
  placement: {
    yPosition: 'above',
    horizontal: true
  },
  content: `View detailed tenure information for Lexus/Toyota Associates. Tenure admins can manually adjust tenure data as needed to maintain accuracy.`
},{
  anchorId: stepKeys['eventDashboard'],
  title: 'Event Registration Dashboard',
  content: "View event details with total registered and withdrawn user counts",
  placement: {
    yPosition: 'above',
    horizontal: true
  },
}, {
  anchorId: stepKeys['information'],
  title: 'Information',
  placement: {
    yPosition: 'above',
    horizontal: true
  },
  content: `View detailed all dropdown data.`
}, {
  anchorId: stepKeys['Support'],
  title: 'Contact Support',
  content: "For any queries or support, please email to this support mailbox."
}, {
  anchorId: stepKeys['lexusLearn'],
  title: 'Lexus Learn',
  content: "External link to Lexus learn application"
}, {
  anchorId: stepKeys['lexusPortal'],
  title: 'LML Portal',
  content: "External link to Lease My Lexus(LML) application"
}, {
  anchorId: stepKeys['certificationByLexus'],
  title: 'Certification By Lexus',
  content: "External link to Certification by Lexus application"
}, {
  anchorId: stepKeys['dealerScorecard'],
  title: 'Dealer Scorecard',
  content: "Snapshot of associate certification health, role mix, tenure, and training across dealers."
},{
  anchorId: stepKeys['googleAnalytics'],
  title: 'Lexus learn Analytics',
  content: "View page view and engagement activity for the Lexus Learn Analytics page."
}]  